import React from "react";

export default function SQL_BETWEEN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_BETWEEN</h1>
      <p>This is the SQL_BETWEEN component generated from the SQL JSON.</p>
    </div>
  );
}
